import React, { Component } from 'react';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import TableC from '../../../../basicElement/TableC';
import format from '../../../../shared/format';

class list extends Component {
    constructor(props) {
        super(props);
        const { curRole } = sessionStorage;
        // this.operatable = false;
        this.operatable = curRole === 'BA' || curRole === 'BAL';
        this.state = {
            loading: false,
            data: [],
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { searchParams: nextSearchParams } = nextProps;
        const { searchParams } = this.props;
        if (nextSearchParams !== searchParams) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.load !== this.props.load) {
            this.loadData();
        }
    }

    loadData = () => {
        const { pagination, sortParams, searchParams, onChange } = this.props;
        const { current, pageSize } = pagination;

        this.setState({ loading: true });
        Fetch.post(API_URL.requestDataAnalysis.queryRemainingJdePendingRequest, {
            offset: current,
            limit: pageSize,
            ...sortParams,
            ...searchParams,
        }).then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            onChange({ pagination });
            this.setState({
                data: datas,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    getColumns = () => {
        const columns = [{
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 100,
        },{
            title: '合同新增时间',
            dataIndex: 'contractCreateTimes',
            key: 'contractCreateTimes',
            sorter: true,
            width: 120,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
        },{
            title: 'JDE主项目号',
            dataIndex: 'investigationJdeMainCode',
            key: 'investigationJdeMainCode',
            width: 100,
        },{
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            width: 100,
        },{
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 120,
        },{
            title: '客户全名',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 120,
        },{
            title: '客户CSA',
            dataIndex: 'customerBaName',
            key: 'customerBaName',
            width: 100,
        },{
            title: 'PM',
            dataIndex: 'pmNameCode',
            key: 'pmNameCode',
            width: 140,
        },{
            title: '主领域leader',
            dataIndex: 'mainTalNameCode',
            key: 'mainTalNameCode',
            width: 140,
        },{
            title: '合同额含税/人民币',
            dataIndex: 'jdeContractAmount',
            key: 'jdeContractAmount',
            sorter: true,
            width: 120,
            render: text => format('money', text),
        },{
            title: '剩余待请款开票合同额含税/人民币（元）',
            dataIndex: 'remainingInvoiceAmount',
            key: 'remainingInvoiceAmount',
            sorter: true,
            width: 180,
            render: text => format('money', text),
        },{
            title: '剩余合同约定请款金额/人民币（元）',
            dataIndex: 'remainingRemittanceAmount',
            key: 'remainingRemittanceAmount',
            sorter: true,
            width: 180,
            render: text => format('money', text),
        }];
        // if (this.operatable) {
        //     columns.push({
        //         title: '操作',
        //         dataIndex: 'operation',
        //         key: 'operation',
        //         width: 100,
        //         render: (text, record) => {
        //             return <a onClick={() => this.handleClick(record)}>登记请款记录</a>;
        //         }
        //     });
        // }
        return columns;
    }

    handleClick = (record) => {
        const { notice } = this.props;
        const { investigationId, investigationName, investigationJdeContractId } = record;
        notice.saveParams({
            investigationId,
            investigationName,
            investigationJdeContractId,
            autoAdd: true
        });
        location.href = '/#/contractManagement/requestRecord';
    }

    handleChange = (params) => {
       this.props.onChange(params, true);
    }

    render() {
        const { height, pagination, sortParams } = this.props;
        const { data, loading } = this.state;
        return (
            <div>
                <TableC
                    data={data}
                    scrollY={height}
                    loading={loading}
                    sortParams={sortParams}
                    pagination={pagination}
                    onChange={this.handleChange}
                    columns={this.getColumns()}
                    className="unregisterRequest"
                />
            </div>
        );
    }
}

export default list;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/UnregisterRequest/TablePage/List.js